
var id = "warn";
var markup = "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"warn\"><defs><style type=\"text/css\"></style></defs><path d=\"M523.264 284.992l-22.016 0c-13.568 0-24.64 11.072-24.64 24.704l0 273.344c0 13.632 11.008 24.832 24.64 24.832l22.016 0c13.696 0 24.768-11.2 24.768-24.832l0-273.344C548.032 296.064 536.96 284.992 523.264 284.992zM512.064 35.392c-263.296 0-476.672 213.376-476.672 476.672 0 263.04 213.376 476.544 476.672 476.544 263.104 0 476.672-213.504 476.672-476.544C988.736 248.768 775.168 35.392 512.064 35.392zM507.712 929.216c-229.056 0-414.656-185.664-414.656-414.72 0-229.12 185.6-414.656 414.656-414.656 229.248 0 414.784 185.536 414.784 414.656C922.496 743.552 736.96 929.216 507.712 929.216zM521.856 694.272l-20.608 0c-13.568 0-24.64 11.072-24.64 24.96l0 25.92c0 13.696 11.008 24.896 24.64 24.896l20.608 0c13.696 0 24.768-11.2 24.768-24.896l0-25.92C546.624 705.28 535.616 694.272 521.856 694.272z\" p-id=\"3692\" fill=\"#faad14\" /></symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
